import { render, staticRenderFns } from "./global-option-form.vue?vue&type=template&id=4ef3d499"
import script from "./global-option-form.vue?vue&type=script&lang=js"
export * from "./global-option-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports